import { z } from 'zod';

const num = () => z.coerce.number();
const numNull = () => z.union([z.coerce.number(), z.null()]);
const boolish = () => z.union([z.boolean(), z.coerce.number()]);

export const StockTransferBrandSummarySchema = z.array(z.object({
  week: z.string(),
  brand_name: z.string().nullable(),
  brand_manager: z.string().nullable().optional(),
  merch_portfolio: z.string().nullable(),
  transfers_raised_qty: num(),
  gpo_count: num(),
  fulfilled_qty: num(),
  short_qty: num().optional().default(0),
  delayed_qty: num(),
  pending_qty: num(),
  fill_rate_pct: num(),
  delay_pct: num(),
  prev_week_fill_rate_pct: numNull(),
  prev_week_delay_pct: numNull(),
}));
export type StockTransferBrandSummary = z.infer<typeof StockTransferBrandSummarySchema>;

export const StockTransferGpoListSchema = z.array(z.object({
  gpo_code: z.string(),
  gpo_id: num(),
  brand_name: z.string().nullable(),
  brand_manager: z.string().nullable().optional(),
  merch_portfolio: z.string().nullable(),
  from_facility_name: z.string(),
  to_facility_name: z.string(),
  requested_quantity: num(),
  received_quantity: num(),
  short_quantity: num().optional().default(0),
  fill_rate_pct: num(),
  is_inwarding_delayed: boolish(),
  inwarding_delayed_by_days: numNull(),
  requested_on: z.string(),
  last_received_on: z.string().nullable(),
  tat_days: numNull(),
  status: z.string(),
}));
export type StockTransferGpoList = z.infer<typeof StockTransferGpoListSchema>;
